import { Ref } from "react";
import { ACCOUNT_CODE_TEXT_MAX_LENGTH } from "@common/schemas/domains/accounting/account.schema";
import { Field } from "@design-system/Field/Field";
import { Input } from "@design-system/Input/Input";
import { InputSize } from "@design-system/Input/Input.types";
import styles from "./AccountCodeNameInput.module.scss";

interface Props {
    codeText: string;
    name: string;
    size: InputSize;
    namePlaceholder?: string;
    nameInputRef?: Ref<HTMLInputElement>;
    className?: string;
    isCodeHidden?: boolean;
    codeError?: string;
    onCodeTextChange: (codeText: string) => void;
    onNameChange: (name: string) => void;
}

export const AccountCodeNameInput = ({
    codeText,
    name,
    size,
    namePlaceholder,
    nameInputRef,
    className,
    isCodeHidden = false,
    codeError,
    onCodeTextChange,
    onNameChange,
}: Props) => (
    <Field label="Name" className={className} error={codeError} invalid={false}>
        <div className={styles.container}>
            {!isCodeHidden && (
                <Field.Root
                    className={styles.codeField}
                    invalid={codeError !== undefined}
                >
                    <Input
                        size={size}
                        placeholder="Code"
                        aria-label="Code"
                        maxLength={ACCOUNT_CODE_TEXT_MAX_LENGTH}
                        className={styles.codeInput}
                        value={codeText}
                        onChange={(event) =>
                            onCodeTextChange(event.target.value)
                        }
                    />
                </Field.Root>
            )}
            <Input
                autoFocus
                ref={nameInputRef}
                size={size}
                placeholder={namePlaceholder}
                className={
                    isCodeHidden ? styles.soloNameInput : styles.nameInput
                }
                value={name}
                onChange={(event) => onNameChange(event.target.value)}
            />
        </div>
    </Field>
);
